<template>
  <div class="green-div">
    <div>
      <v-img
        src="/assets/backgrondTitle.png"
        :max-height="isDashboard ? 150 : 120"
      >
        <img
          class="my-4 mx-2"
          src="/assets/iconTitle.png"
          :width="150"
          v-if="isDashboard"
        />
        <v-row v-if="isDashboard" class="mx-6 center-all">
          <v-col class="center-all ma-0 pa-0" cols="8">
            <v-autocomplete
              v-model="findLocation"
              :items="locationList"
              item-text="name"
              return-object
              prepend-inner-icon="mdi-magnify"
              :label="$t('generics.search')"
              solo
              clearable
              hide-details
              height="48"
              flat
              class="gold-border rounded-lg rounded-l-0"
            />
          </v-col>
          <v-col
            class="white center-all gold-border right-border-none left-border-none rounded-lg rounded-r-0 rounded-l-0"
            cols="2"
            xl="1"
          >
            <img
              src="/assets/locationRefresh.png"
              :width="21"
              @click="setMeToMyLocation"
            />
          </v-col>
          <v-col
            class="bibleGreen center-all gold-border right-border-none left-border-none rounded-lg rounded-r-0"
            cols="2"
            xl="1"
          >
            <v-icon @click="openDrawer" color="white">mdi-menu</v-icon>
          </v-col>
        </v-row>
        <v-row v-else class="mx-8 center-all pt-5">
          <v-col cols="9">
            <img
              class="my-4 mx-2"
              src="/assets/iconTitle.png"
              :width="isDashboard ? 150 : 200"
            />
          </v-col>
          <v-col cols="2" xl="1">
            <div class="white center-all gold-border rounded-lg py-3 px-7">
              <v-icon @click="openDrawer" color="gold">mdi-menu</v-icon>
            </div>
          </v-col>
          <v-col></v-col>
        </v-row>
      </v-img>
    </div>
    <slot name="app" class="app-title" />
  </div>
</template>

<script>
import googleMap from "@/mixins/googleMap"

export default {
  name: "ThemeHeader",
  data() {
    return {
      drawerIsOpen: false,
      menuOptions: [
        { icon: "mdi-map-marker-radius", text: "ראשי" },
        { icon: "mdi-history", text: "הסטוריית מיקומים" },
        { icon: "mdi-binoculars", text: "אודות" },
        { icon: "mdi-message ", text: "צור קשר/תרום ידע" },
      ],
      findLocation: null,
    }
  },
  mixins: [googleMap],
  computed: {
    isDashboard() {
      return this.$route.name == "Dashboard"
    },
    points() {
      return this.$store.getters.points
    },
    myPoint() {
      return this.$store.getters.myPoint
    },
    locationList() {
      return this.points.filter((p) => p.type !== "myLocation")
    },
  },
  methods: {
    openDrawer() {
      this.$emit("toggleMenu", true)
    },
    setMeToMyLocation() {
      this.setMyLocation()
      if (this.myPoint) {
        this.setMeToLocation(this.myPoint)
      }
    },
  },
  watch: {
    async findLocation(newSelected) {
      if (newSelected) {
        this.setMeToLocation(newSelected)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../styles/global.scss";
.green-div {
  background: var(--transitionGreen);
}
.gold-border {
  border: solid 3px var(--gold) !important;
}
.right-border-none {
  border-right: none !important;
}
.left-border-none {
  border-left: none !important;
}
.cursor {
  cursor: pointer;
}
.menu-location {
  position: absolute;
  left: 20px;
  top: 15px;
}
.app-title {
  border-radius: 50%;
  background-color: aliceblue;
}
</style>
